import { createFileRoute } from '@tanstack/react-router'
import { FabricExtractorDetailPage } from '@bloo-team/product-fabric'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): the extractor
 * workbench (docs/extractors-requirements.md W2). `$extractorId` is the row id
 * as the list carries it — "730", "730_gotham", "730_gotham_draft".
 */
function ExtractorDetailRoute() {
  const { clusterId, scopeId, extractorId } = Route.useParams()
  return <FabricExtractorDetailPage clusterId={clusterId} scopeId={scopeId} extractorId={extractorId} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/extractors_/$extractorId')({
  component: ExtractorDetailRoute,
})
